import { render } from "./Typography.vue?vue&type=template&id=1d71f6e4&ts=true"
import script from "./Typography.vue?vue&type=script&setup=true&lang=ts"
export * from "./Typography.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ui/Typography/Typography.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1d71f6e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1d71f6e4', __exports__)) {
    api.reload('1d71f6e4', __exports__)
  }
  
  module.hot.accept("./Typography.vue?vue&type=template&id=1d71f6e4&ts=true", () => {
    api.rerender('1d71f6e4', render)
  })

}


export default __exports__